import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import ImageCropper from '../../../common/ImageCropper/ImageCropper.js'

class TripItineraryAdd extends React.Component {
  state = {
    status: 'active',
    name_en: '',
    name_ar: '',
    capacity: '',
    max_cabins: '',
    price: '',
    img_en: '',
    img_ar: '',
    order: '',
    is_active: false,
    isSaving: false,
    isData: false,
    Edit: false,
    trip_itinerary_items: [],
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.id) {
        this.getCruiseItineraryDetails()
      } else {
        this.addItinerary()
      }
    }, 100)
  }

  getCruiseItineraryDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-trip-itinerary-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const tripItineraryData = res.data.data
          this.setState({
            ...tripItineraryData,
            trip_itinerary_items: tripItineraryData.itinerary_info,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    if (event?.target?.name === 'is_active') {
      this.setState({ [event.target.name]: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
    if (imgKeyName == 'img_ar') {
      this.setState({ imgAr: URL.createObjectURL(e) })
    } else {
      this.setState({ imgEn: URL.createObjectURL(e) })
    }
  }

  onSaveData = () => {
    const formData = new FormData()
    formData.append('trip_id', this.props.tripId)
    formData.append('itinerary_info', JSON.stringify(this.state.trip_itinerary_items))

    this.setState({ isData: true })

    if (this.state.img_en?.type) {
      formData.append('img_en', this.state.img_en, 'your_original_filename.jpeg')
    }
    if (this.state.img_ar?.type) {
      formData.append('img_ar', this.state.img_ar, 'your_original_filename.jpeg')
    }

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + '/trips/update-trip-itinerary', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Cruise Itinerary has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/trips/add-trip-itinerary', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Cruise Itinerary has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  addItinerary = () => {
    const newEntry = {
      title_en: '',
      title_ar: '',
      description_en: '',
      description_ar: '',
    }
    const dataCopy = [...this.state.trip_itinerary_items, newEntry]

    this.setState({
      ...this.state,
      trip_itinerary_items: dataCopy,
    })
  }

  removeItemOption = (index) => {
    const dataCopy = [...this.state.trip_itinerary_items]
    dataCopy.splice(index, 1)
    this.setState({ trip_itinerary_items: dataCopy })
  }

  handleItineraryChange = (event, index) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.trip_itinerary_items]
    dataCopy[index][name] = value
    this.setState({
      ...this.state,
      trip_itinerary_items: dataCopy,
    })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: English</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="card border">
              <div
                className="card-header"
                style={{ paddingTop: 15, paddingBottom: 15 }}
              >
                <h3 className="float-left card-title">Add Itinerary</h3>
                <span className="float-right m-0">
                  <button
                    disabled={this.state.readOnly}
                    className="btn btn-primary btn-sm"
                    onClick={this.addItinerary}
                  >
                    Add More
                  </button>
                </span>
              </div>
              {this.state.trip_itinerary_items && this.state.trip_itinerary_items.length ? (
                <div className="card-body">
                  {this.state.trip_itinerary_items.map((item, i) => {
                    return (
                      <div
                        className="card border m-0"
                        key={i}
                        style={{ background: '#ffe' }}
                      >
                        <div
                          className="card-header"
                          style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                        >
                          <h5 className="float-left card-title">Day {i + 1}#</h5>
                          <span className="float-right">
                            <button
                              disabled={this.state.readOnly}
                              className="btn btn-danger btn-sm"
                              onClick={() => this.removeItemOption(i)}
                            >
                              Remove
                            </button>
                          </span>
                        </div>
                        <div className="card-body row">
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Title in English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="title_en"
                                  placeholder="Title in English"
                                  onChange={(event) => this.handleItineraryChange(event, i)}
                                  value={item.title_en}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Title in Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="title_ar"
                                  placeholder="Title in Arabic"
                                  onChange={(event) => this.handleItineraryChange(event, i)}
                                  value={item.title_ar}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Description in English</label>
                              <div className="col-sm-9">
                                <textarea
                                  className="form-control"
                                  name="description_en"
                                  id="description_en"
                                  placeholder="Description in English"
                                  onChange={(event) => this.handleItineraryChange(event, i)}
                                  value={item.description_en}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Description in Arabic</label>
                              <div className="col-sm-9">
                                <textarea
                                  className="form-control"
                                  name="description_ar"
                                  id="description_ar"
                                  placeholder="Description in Arabic"
                                  onChange={(event) => this.handleItineraryChange(event, i)}
                                  value={item.description_ar}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : null}
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/cruise-trip-itinerary/${this.props.tripId}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default TripItineraryAdd
